// Web shim to map native-stack API to stack API
import { createStackNavigator } from '@react-navigation/stack';

export const createNativeStackNavigator = createStackNavigator;

export default {
  createNativeStackNavigator,
};
